import OTPLogin from "./OTPLogin";

export default OTPLogin;
